import { useEffect } from 'react';
import { AI_NAVIGATION_MESSAGES } from '../../constants';

function UseNativeListener(sendMessage: (msg: string) => void, language: string) {
    useEffect(() => {
        const patchHistory = (type) => {
            const original = window.history[type];
            return function () {
                const result = original.apply(this, arguments);
                const event: any = new Event(type);
                event.arguments = arguments;
                window.dispatchEvent(event); // Trigger a custom event
                return result;
            };
        };

        // Patch both pushState and replaceState
        window.history.pushState = patchHistory('pushState');
        window.history.replaceState = patchHistory('replaceState');

        const handleLocationChange = () => {
            const route = window.location.pathname.split('/')[1] as keyof typeof AI_NAVIGATION_MESSAGES;
            const nestedRoute = window.location.pathname.split('/').length > 2;
            if (Object.keys(AI_NAVIGATION_MESSAGES).includes(route) && route !== "dashboard" && !nestedRoute) {
                sendMessage(AI_NAVIGATION_MESSAGES[route][language]);
            }
        };

        // Listen for back/forward buttons
        window.addEventListener('popstate', handleLocationChange);
        window.addEventListener('pushState', handleLocationChange);
        window.addEventListener('replaceState', handleLocationChange);

        return () => {
            window.removeEventListener('popstate', handleLocationChange);
            window.removeEventListener('pushState', handleLocationChange);
            window.removeEventListener('replaceState', handleLocationChange);
        };
    }, []);

    return null;
}
export default UseNativeListener;